import { useEffect } from "react";
import { EndSessionRequest } from "@azure/msal-browser";
import { useDispatch } from "react-redux";
import { fetchUserData } from "./UserStore";
import { AppDispatch } from "../app/Store";
import { useSomaAuth } from "../auth/SomaAuthContext";
const useSetupUserInfo = () => {
  const { currentAccount, currentLocalUser, isLocalAuthEnabled, msalInstance } = useSomaAuth();
  const dispatch = useDispatch<AppDispatch>();
  const accountName = currentAccount?.name;
  const accountOid = currentAccount?.idTokenClaims?.oid;
  const localAccountName = currentLocalUser?.name;
  const localAccountOid = currentLocalUser?.objectId;

  useEffect(() => {
    if (isLocalAuthEnabled) {
      if (!localAccountName) {
        return;
      }

      const dispatchedAction = dispatch(
        fetchUserData({ accountName: localAccountName, oid: localAccountOid })
      );
      return () => dispatchedAction.abort();
    }

    if (!accountName || accountName.length <= 0) {
      console.error("User does not have a name.");
      msalInstance?.logoutRedirect({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      } as EndSessionRequest);
      return;
    }
    const dispatchedAction = dispatch(fetchUserData({ accountName: accountName, oid: accountOid }));
    return () => dispatchedAction.abort();
  }, [
    accountName,
    accountOid,
    dispatch,
    isLocalAuthEnabled,
    localAccountName,
    localAccountOid,
    msalInstance,
  ]);
};
export default useSetupUserInfo;
